import kvm from '@/api/kvm'
import { SERVICE_TYPES } from '@/consts/service'

/** The customer's active KVM servers, from the shared (billing) service list. */
export const kvmServices = services =>
  (services || []).filter(s => s.type === SERVICE_TYPES.KVM && s.status === 'Active')

/**
 * What the Applications pages need about one KVM server: whether it's a Docker
 * host (or about to be — a new server installing the app chosen with it), what
 * to call it, its address and whether it's on. Resolves to null for a server
 * that isn't a Docker host. Each server is asked separately (its own token).
 *
 * @param {Object} svc a billing service row ({ id, domain, name })
 */
export async function dockerServerInfo (svc) {
  const server = await kvm.getServer(svc.id)
  if (!server.docker_enabled && !server.docker_app_install) return null
  return {
    id: String(svc.id),
    // Same name the Servers list shows: the customer's label, else the billing name.
    name: server.custom_label || svc.domain || svc.name,
    hostname: server.hostname,
    ip: server.primary_ip,
    location: server.location,
    docker: server.docker_enabled,
    online: server.power_state === 'online',
    building: server.provisioning_state !== 'provisioned' || server.vm_status === 'provisioning',
    install: server.docker_app_install,
    // Live load (KvmServerResources adds disk and the last hour's history).
    cpu: server.cpu_used_percent,
    ram: { total: server.ram_total, used: server.ram_used },
    metricsHistory: !!(server.capabilities && server.capabilities.metrics_history),
  }
}

/** Short text for why a server's apps can't be shown or deployed to right now (null = fine). */
export function dockerServerUnavailable (server) {
  if (server.building) return 'Being set up…'
  if (!server.docker) return 'Docker is being set up…'
  if (!server.online) return 'Powered off — start it to manage its apps.'
  return null
}
